var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportShieldOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 15.0479V29.952C39 32.3082 37.7751 34.486 35.7877 35.6642L23.2133 43.1162C21.2239 44.2944 18.7742 44.2944 16.7867 43.1162L4.21227 35.6642C2.22485 34.486 1 32.3082 1 29.952V15.0479C1 12.6916 2.22485 10.5138 4.21227 9.33565L16.7867 1.8836C18.7761 0.705467 21.2258 0.705467 23.2133 1.8836L35.7877 9.33565C37.7751 10.5138 39 12.6916 39 15.0479Z",
    fill: "#FFD9CD",
    stroke: "#DE3714",
    strokeWidth: 0.485794,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1501 16.2331V28.7661C36.1501 30.7475 35.109 32.5789 33.4197 33.5696L22.7314 39.8361C21.0404 40.8268 18.9581 40.8268 17.2688 39.8361L6.58053 33.5696C4.89122 32.5789 3.8501 30.7475 3.8501 28.7661V16.2331C3.8501 14.2517 4.89122 12.4204 6.58053 11.4297L17.2688 5.16319C18.9598 4.17249 21.0421 4.17249 22.7314 5.16319L33.4197 11.4297C35.109 12.4204 36.1501 14.2517 36.1501 16.2331Z",
    fill: "#FFD9CD",
    stroke: "#DE3714",
    strokeWidth: 0.485794,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9175 1.04907V4.48074C21.5467 4.58945 22.1614 4.81092 22.7313 5.14516L33.4196 11.4116C35.1089 12.4024 36.15 14.2337 36.15 16.2151V23.814H39V15.0296C39 12.6733 37.7752 10.4955 35.7878 9.31733L23.2133 1.86529C22.494 1.43889 21.7141 1.16682 20.9175 1.04907Z",
    fill: "url(#paint0_linear_561_539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_539",
    x1: 35.9863,
    y1: 12.1981,
    x2: 37.7551,
    y2: 21.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA957F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportShieldOrange);
export default __webpack_public_path__ + "static/media/passport-shield-orange.c9c9e46dbacda1c855cbe31c802bed7e.svg";
export { ForwardRef as ReactComponent };